// URL search-param coercer for /management/payment-logs.
//
// The backend (`paymentLogs.findAll`) is hard-scoped to the caller's
// organization. The list page intentionally surfaces **all logs in the org**
// by default — there is no implicit `accountId` filter derived from the
// current user. An `accountId` filter can be set from the UI, in which case
// it lands in this object.
export type PaymentLogsSearch = {
  search?: string;
  statuses?: string[];
  billingTypes?: string[];
  customerIds?: string[];
  itineraryIds?: string[];
  // Optional per-user filter; opt-in from the toolbar. Stays absent when
  // the caller wants the full org-wide view (default).
  accountId?: string;
  startDate?: string;
  endDate?: string;
  createdStartDate?: string;
  createdEndDate?: string;
  page?: number;
};

const asStringArray = (v: unknown): string[] | undefined =>
  Array.isArray(v)
    ? v.filter((x): x is string => typeof x === 'string' && x.length > 0)
    : undefined;

const asString = (v: unknown): string | undefined =>
  typeof v === 'string' && v.length > 0 ? v : undefined;

export const validatePaymentLogsSearch = (
  input: Record<string, unknown>
): PaymentLogsSearch => ({
  search: asString(input.search),
  statuses: asStringArray(input.statuses),
  billingTypes: asStringArray(input.billingTypes),
  customerIds: asStringArray(input.customerIds),
  itineraryIds: asStringArray(input.itineraryIds),
  accountId: asString(input.accountId),
  startDate: asString(input.startDate),
  endDate: asString(input.endDate),
  createdStartDate: asString(input.createdStartDate),
  createdEndDate: asString(input.createdEndDate),
  page: typeof input.page === 'number' ? input.page : undefined,
});
